import { useQuery } from 'react-query';
import { useAuth0 } from '@auth0/auth0-react';
import setToken from '../../utils/api';
import { ConversationSummary } from '../../types/IAiConversation';

export const AI_CONVERSATIONS_KEY = 'ai-conversations';

// The signed-in admin's conversations, newest first.
export default function useAiConversations() {
  const { getAccessTokenSilently } = useAuth0();
  return useQuery<ConversationSummary[], Error>(
    [AI_CONVERSATIONS_KEY],
    async () => {
      const token = await getAccessTokenSilently();
      const api = await setToken(token);
      const response = await api.get<ConversationSummary[]>(
        'api/ai/conversations',
      );
      if (response.status !== 200)
        throw new Error('Could not load conversations');
      return [...response.data].sort((a, b) =>
        b.dateUpdated.localeCompare(a.dateUpdated),
      );
    },
    { refetchOnWindowFocus: false },
  );
}
